import angular from "angular";
import angularMask from "angular-ui-mask";
import core from "../../core/core.module";

angular
    .module('app')
    .component('customerUserForm', {
        controller: ['notifier', '$http', controller],
        template: require('./customer-user-form.html'),
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller(notifier, $http) {

    const $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.user = $ctrl.resolve.user;
        $ctrl.roles = $ctrl.resolve.roles;

        $ctrl.lastName = $ctrl.user.last_name;
        $ctrl.firstName = $ctrl.user.first_name;
        $ctrl.email = $ctrl.user.email;
        $ctrl.phone = $ctrl.user.phone;
        $ctrl.position = $ctrl.user.position;
        $ctrl.code = $ctrl.user.code;
        $ctrl.isActive = $ctrl.user.is_active;

        $ctrl.roles.forEach(role => {
            role.isSelected = $ctrl.user.roles.findIndex(v => v.id === role.id) !== -1;
        });
    };

    $ctrl.submit = function () {

        $ctrl.loading = true;

        let params = {
            last_name: $ctrl.lastName,
            first_name: $ctrl.firstName,
            email: $ctrl.email,
            phone: $ctrl.phone,
            is_active: $ctrl.isActive,
            position: $ctrl.position,
            roles: $ctrl.roles.filter(v => v.isSelected).map(v => v.id),
        };

        $http
            .post(`/users/${$ctrl.user.id}`, params)
            .then(res => {
                notifier.successNotify('Данные пользователя успешно обновились', 2000);
                $ctrl.close();
            })
            .catch(err => {
                notifier.errorResponseNotify(err);
            })
            .finally(() => {
                $ctrl.loading = false;
            });
    };

}




// WEBPACK FOOTER //
// ./resources/assets/modules/components/customer-user-form/customer-user-form.js